import React from 'react';
import { Link, useParams, Navigate } from 'react-router-dom';
import { guides } from '../data/admissionData';
import { AnalyticsEvents, trackEvent } from '../utils/analytics';
import { usePageMeta } from '../hooks/usePageMeta';
import '../styles/Guides.css';

const GuideBody = ({ blocks }) => {
  if (!blocks?.length) {
    return <p className="apple-guide-status">본문 준비 중</p>;
  }

  return (
    <div className="apple-article-body">
      {blocks.map((block, index) => {
        if (block.type === 'h3') {
          return <h3 key={index}>{block.text}</h3>;
        }
        if (block.type === 'ul') {
          return (
            <ul key={index}>
              {block.items.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          );
        }
        if (block.type === 'note') {
          return (
            <aside key={index} className="apple-article-note">
              {block.text}
            </aside>
          );
        }
        return <p key={index}>{block.text}</p>;
      })}
    </div>
  );
};

const GuideDetail = () => {
  const { guideId } = useParams();
  const guide = guides.find((item) => item.id === guideId);

  usePageMeta({
    title: guide?.title || '가이드',
    description: guide?.summary || '일본 입시 가이드. 참고용이며 모집요항 원문이 우선입니다.',
    path: guide ? `/guides/${guide.id}` : '/guides',
    type: 'article',
  });

  if (!guide) {
    return <Navigate to="/guides" replace />;
  }

  return (
    <article className="apple-page apple-article">
      <p className="apple-eyebrow">{guide.category}</p>
      <h1 className="apple-display">{guide.title}</h1>
      <p className="apple-article-meta">
        {guide.readTime} · 업데이트 {guide.updatedAt || '—'}
      </p>
      <p className="apple-lede">{guide.summary}</p>

      <GuideBody blocks={guide.body} />

      <div className="apple-page-foot apple-article-foot">
        <Link to="/guides" className="apple-link">
          모든 가이드
        </Link>
        {guide.id === 'yokoan-howto' ? (
          <Link to="/checklist" className="apple-link">
            요강 체크리스트
          </Link>
        ) : (
          <Link to="/finder" className="apple-link">
            루트 파인더
          </Link>
        )}
        <Link
          to="/consulting"
          className="apple-btn apple-btn-primary"
          onClick={() =>
            trackEvent(AnalyticsEvents.GUIDE_CTA_CONSULT, { guideId: guide.id })
          }
        >
          컨설팅 신청
        </Link>
      </div>
    </article>
  );
};

export default GuideDetail;
